module.exports = __webpack_public_path__ + "static/media/N5.696b793a.png";